import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { DisplayLarge, DisplaySmall, HeadlineMedium } from '../../styles';
import { Breakpoint } from '../../types';
import { shouldForwardProps } from '../../utils';
import { HeaderType } from './ContentHeader';

export const ContentHeaderContainer = styled(Box, shouldForwardProps)<{
    breakpoint: Breakpoint;
    headerType: HeaderType;
    isScrolled?: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: flex-end;
    position: ${({ isScrolled }) => isScrolled !== undefined && 'sticky'};
    top: ${({ isScrolled }) => isScrolled && '80px'};
    background: ${({ isScrolled, theme }) => isScrolled && theme.colors.background};
    padding-bottom: ${({ isScrolled, theme }) => isScrolled && theme.spacing(3)};
    z-index: ${({ isScrolled }) => isScrolled && '3'};
`;

export const ContentHeaderBottomRow = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const ContentHeaderTitleBig = styled(DisplayLarge)<{ type: HeaderType }>`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    white-space: normal;
    color: ${({ theme, type }) =>
        type === HeaderType.MAIN_PAGE ? theme.colors.onPrimaryDark : theme.colors.onSurfaceVariant};
`;

export const ContentHeaderTitleMedium = styled(DisplaySmall)<{ type: HeaderType }>`
    color: ${({ theme, type }) =>
        type === HeaderType.MAIN_PAGE ? theme.colors.onPrimaryDark : theme.colors.onSurfaceVariant};
`;

export const ContentHeaderTitleSmall = styled(HeadlineMedium)<{ type: HeaderType }>`
    color: ${({ theme, type }) =>
        type === HeaderType.MAIN_PAGE ? theme.colors.onPrimaryDark : theme.colors.onSurfaceVariant};
`;
